// libraries
import "script-loader!jquery";
import "script-loader!../../../../mu-plugins/gravityforms/js/jquery.json.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/gravityforms.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/jquery.maskedinput.min.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/placeholders.jquery.min.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/conditional_logic.min.js";
import "script-loader!../../../../plugins/gravityformsutmtracking/js/jquery-utmz";
import "script-loader!./lib/forms.js";

// Excluded: alert, button, carousel, popover, scrollspy, tooltip
import "script-loader!../../node_modules/bootstrap/js/dist/util";
import "script-loader!../../node_modules/bootstrap/js/dist/collapse";
import "script-loader!../../node_modules/bootstrap/js/dist/dropdown";
import "script-loader!../../node_modules/bootstrap/js/dist/modal";
import "script-loader!../../node_modules/bootstrap/js/dist/tab";

import {oncarrotMap} from "../../../../plugins/oncarrot-map";

import {shimCatch} from "./lib/head-catch";
shimCatch();

import {navbarParentClickableCompat} from "./lib/bootstrap-navwalker";

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Carrot = {
    // All pages
    'common': {
      init: function() {
        $().utmz({ domainName: false });

        navbarParentClickableCompat($);

        // Compatibility with our lazy loading YouTube functionality, remove embed wrapper from output
        $('.entry-content-asset .carrot-lazyload-youtube').closest('.wp-block-embed__wrapper').unwrap();

        // Process Carrot Map Queue
        oncarrotMap();

        // Datepicker
        $('.datepicker').each(function(e) {
          e = $(this);

          var dateFormat;
          if (e.hasClass('mdy')) {
            dateFormat = 'mm/dd/yy';
          } else if (e.hasClass('dmy')) {
            dateFormat = 'dd/mm/yy';
          } else if (e.hasClass('dmy_dash')) {
            dateFormat = 'dd-mm-yy';
          } else if (e.hasClass('dmy_dot')) {
            dateFormat = 'dd.mm.yy';
          } else if (e.hasClass('ymd_slash')) {
            dateFormat = 'yy/mm/dd';
          } else if (e.hasClass('ymd_dash')) {
            dateFormat = 'yy-mm-dd';
          } else if (e.hasClass('ymd_dot')) {
            dateFormat = 'yy.mm.dd';
          }
          var dateFormatAlt = dateFormat.replace('yy', 'yyyy');

          $('.gform_wrapper input.datepicker').removeAttr('type').prop('type', 'date').attr('dateformat', dateFormat);
        });

        // Share buttons
        $('.entry-share-btns a, a.sharewindow').on('click', function(e) {
          e.preventDefault();
          var link = $(this).attr('href');
          var width = 840;
          var height = 464;
          var popupName = 'popup_' + width + 'x' + height;
          var left = (screen.width-width) / 2;
          var top = 100;
          var params = 'width=' + width + ',height=' + height + ',location=no,menubar=no,scrollbars=yes,status=no,toolbar=no,left=' + left + ',top=' + top;
          window[popupName] = window.open(link, popupName, params);
          if (window.focus) {
            window[popupName].focus();
          }
          return true;
        });

        // Auto-submit specific forms when a select changes
        $('.autosubmit select').one('change', function() {
          $(this).parents("form").addClass('disabled');
          $(this).parents("form").submit();
        });

        // Columns block
        if ($('.wp-block-columns').length > 0) {
          $('.wp-block-columns').each(function () {
            $(this).addClass('has-' + $(this).children().length + '-columns');
          });
        }

        // Gravity Forms multi-upload assets
        // Needs to be mirrored to `gform_file_upload_markup` in extras.php
        gform.addFilter('gform_file_upload_markup', function (html, file, up, strings) {
          var formId = up.settings.multipart_params.form_id,
              fieldId = up.settings.multipart_params.field_id;
              html = '<strong>' + file.name + "</strong> <img class='gform_delete' "
              + "src='data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\"><path d=\"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z\"/></svg>'"
              + "style='height: 1rem; cursor: pointer;' onclick='gformDeleteUploadedFile(" + formId + "," + fieldId + ", this);' "
              + "alt='Delete'>";

          return html;
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Supplement placeholder values for inline hero form layout
        jQuery(".hero-layout-inline .gform_fields :text").attr("placeholder", function() {
          var eId         = jQuery(this).attr("id");
          var placeholder = jQuery(this).attr("placeholder");
          var label       = jQuery(this).parents("form").find("label[for="+eId+"]");
          if (eId && !placeholder && label.length == 1) {
            jQuery(this).attr("placeholder", jQuery(label).text());
          }
        });
      }
    },
    // Single IDX property page
    'single_idx_property': {
      init: function () {
        // Move inquiry CTA from end of content to above tabs
        if ($('.main .inquiry-btn-wrap').length > 0) {
          $('.main .inquiry-btn-wrap').insertBefore('#ihf-detail-extrainfotabs');
          $('.main .inquiry-btn-wrap').clone().insertBefore('#ihf-detail-extrainfotabs.visible-xs');
        }

        if ($('.main .widget-inquiry').length > 0) {
          $('.main .widget-inquiry').insertBefore('#ihf-detail-extrainfotabs');
          $('.main .widget-inquiry').clone().insertBefore('#ihf-detail-extrainfotabs.visible-xs');
        }
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Carrot;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



// WEBPACK FOOTER //
// ./assets/scripts/main.js